import { motion, useAnimation } from 'framer-motion'
import React, { useContext, useEffect } from 'react'
import styled, { css } from 'styled-components'
import LayoutContext from './LayoutContext'
import SlideshowSlider from './SlideshowSlider'
import media from 'css-in-js-media'

const ActiveState = css`
    display: flex;
`

export const ZoomWrapper = styled(motion.div)`
    background-color: black;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: none;
    z-index: 11000;
    pointer-events: none;

    ${(props) =>
        props.active &&
        css`
            pointer-events: all;
        `}
`

const SliderWrapper = styled.div`
    height: 100%;
    width: 100%;
    display: none;
    .gatsby-image-wrapper {
        height: 100%;
    }
    .swiper-pagination {
        top: 48px;
        left: 80px;

        ${media('<desktop')} {
            top: 26px;
            left: 20px;
        }
    }
    .SlideshowContent {
        padding-left: 80px;

        ${media('<desktop')} {
            padding-left: 30px;
        }
    }

    .SlideshowPrev {
        left: 80px;
        ${media('<desktop')} {
            left:20px;
        }
    }

    .SlideshowNext {
        right: 80px;
        ${media('<desktop')} {
            right: 20px;
        }
    }

    ${(props) => props.active && ActiveState}
`

const ZoomInner = styled.div`
    width: 100%;
    height: 100%;
`

const ZoomSlideshow = ({}) => {
    const { isSlideshow, isZoomOpen } = useContext(LayoutContext)

    const controls = useAnimation()

    useEffect(() => {
        controls.start(isZoomOpen ? 'active' : 'inactive') // Second should be 'inactive'
    }, [isZoomOpen, controls])

    const ZoomAnimationStyles = {
        inactive: {
            opacity: 0,
            scale: 1.02,
            transitionEnd: { display: 'none' },
        },
        active: {
            opacity: 1,
            scale: 1,
            display: 'flex',
        },
    }

    return (
        <>
            <ZoomWrapper
                active={isZoomOpen}
                animate={controls}
                variants={ZoomAnimationStyles}
                transition={{
                    type: 'spring',
                    stiffness: 10,
                    default: { duration: 0.5 },
                }}
            >
                {isSlideshow.map((slide, index) => (
                    <SliderWrapper key={index} active={isZoomOpen == slide.id && true}>
                        <ZoomInner>
                            <SlideshowSlider data={slide.data} isZoom />
                        </ZoomInner>
                    </SliderWrapper>
                ))}
            </ZoomWrapper>
        </>
    )
}

export default ZoomSlideshow
